module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-2.87ca5b99.jpg";